import type { CardType, ProductCardProps } from '../types';
import classNames from 'classnames';
import AddCart from '@/components/common/AddCartNew/index-enki';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';

const ProductAddCart: React.FC<Partial<
  ProductCardProps &
    CardType & {
      addCartBtnClassName?: string;
      customTooltipCls?: string;
      remindedFontClassName?: string;
      remindFontClassName?: string;
      changeOtherDayFontClassName?: string;
      purchaseClassName?: string;
      showPurchaseStatus?: boolean;
      text?: string;
      addBtnClassName?: string;
      isHoriziontal?: boolean;
      hideIcon?: boolean;
    }
>> = props => {
  const {
    data,
    showAddBtn = true,
    addCartParams,
    preSell,
    onATC,
    produtLink,
    trackDataInDialog,
    cardType,
    positionInfoT2,
    useNewUpdateCartApi,
    addCartBtnClassName,
    addCartApiFn,
    addBtnClassName,
    ...rest
  } = props;

  const { t } = useTranslation('common');

  return (
    <div className="pointer-events-auto" onClick={e => e.stopPropagation()}>
      {data?.category === 'bundle' || data?.is_hotdish === 'Y' ? (
        <div className={twMerge('text-center absolute bottom-2 right-2 z-[1]', addCartBtnClassName)}>
          <span data-testid="btn-view">{t('btn_view')}</span>
        </div>
      ) : showAddBtn ? (
        <div className={twMerge('text-center absolute bottom-2 right-2 z-[1]', addCartBtnClassName)}>
          <div
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <AddCart
              {...addCartParams}
              remindedFontClassName={props.remindedFontClassName}
              remindFontClassName={props.remindFontClassName}
              useNewUpdateCartApi={useNewUpdateCartApi}
              positionInfoT2={positionInfoT2}
              cardType={cardType}
              preSell={preSell}
              data={data}
              link={produtLink?.to}
              onNumChange={onATC}
              isInProductCard
              trackDataInDialog={trackDataInDialog}
              customAddCartApi={props?.customAddCartApi}
              addCartApiFn={addCartApiFn}
              {...rest}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ProductAddCart;
